import Contributor from './Contributor'

export default Contributor
